module.exports = __webpack_public_path__ + "img/ic_price@2x.5b1cf382.png";